"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DisabledLink = function DisabledLink(props, ref) {
  var to = props.to,
      children = props.children,
      rest = _objectWithoutProperties(props, ["to", "children"]);

  return _react.default.createElement("span", _extends({}, rest, {
    ref: ref
  }), children);
};

var DisabledLinkWithRef = (0, _react.forwardRef)(DisabledLink);
var disabledLinkStyles = (0, _styledComponents.css)(["cursor:not-allowed;color:", ";", ";"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal40), _styles.sharedLinkStyles);

var _default = (0, _styledComponents.default)(DisabledLinkWithRef).withConfig({
  displayName: "DisabledLink",
  componentId: "sc-129tszc-0"
})(["", ""], disabledLinkStyles);

exports.default = _default;